module.exports = __webpack_public_path__ + "static/media/login-twitter.f1f7518f.svg";